import { FC } from 'react';

import BackButton, { BackButtonProps } from 'components/BackButton';

const LoginBackButton: FC<BackButtonProps> = (props) => (
  <BackButton marginBottom="space-40" size="md" {...props} />
);

export default LoginBackButton;
